import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { compareDates } from "../../../utils/datesHeures";
import QRCode from "react-qr-code";

const ComponentCalendrier = (props) => {
  const { calendrier, emailResponsable, nomSalle } = props;
  var dateJour = new Date();
  let ajoutFuseauHoraire = -dateJour.getTimezoneOffset() / 60;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { t } = useTranslation();

  const afficheEnteteJour = (jour) => {
    const dateSplit = jour.split("-");
    return dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0];
  };

  const BarreRdv = (objet) => {
    const leRDV = objet.props;

    let DebutJournee = new Date(leRDV.dateDebut);
    DebutJournee.setHours(8);
    DebutJournee.setMinutes(0);
    DebutJournee.setSeconds(0);
    DebutJournee = new Date(DebutJournee).valueOf();

    let isoDateStart = new Date(leRDV.dateDebut);
    let isoDateEnd = new Date(leRDV.dateFin);
    isoDateStart.setHours(isoDateStart.getHours() + ajoutFuseauHoraire);
    isoDateEnd.setHours(isoDateEnd.getHours() + ajoutFuseauHoraire);
    leRDV.start_time = new Date(isoDateStart).valueOf();
    leRDV.end_time = new Date(isoDateEnd).valueOf();

    let depart = ((leRDV.start_time - DebutJournee) / 1000 / 60 / 60) * 50;
    let longueur = ((leRDV.end_time - leRDV.start_time) / 1000 / 60 / 60) * 50;

    return (
      <div className="barreRDV" style={{ left: depart + "px", width: longueur + "px" }}>
        {/* {leRDV.sujet} */}
      </div>
    );
  };

  return (
    <div>
      <div className="contentTableCalendrier">
        <Table striped bordered hover className="calendrier">
          <thead className="enteteDates">
            <tr>
              <th className="colonneSticky"></th>
              <th>8h</th>
              <th>9h</th>
              <th>10h</th>
              <th>11h</th>
              <th>12h</th>
              <th>13h</th>
              <th>14h</th>
              <th>15h</th>
              <th>16h</th>
              <th>17h</th>
              <th>18h</th>
              <th>19h</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(calendrier).map((jour, index, rdvs) => (
              <tr key={"jour_" + index}>
                <td
                  className={
                    compareDates(jour, dateJour) ? "jour colonneSticky today" : "jour colonneSticky"
                  }
                >
                  {afficheEnteteJour(jour)}
                </td>
                <td className="position-relative horaire">
                  {calendrier[jour].map((rdv, index) => (
                    <BarreRdv props={rdv} key={index} />
                  ))}
                </td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
                <td className="horaire"></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {ReduxInstance.urlReservationSalle !== "" && (
        <div className="mt-3 text-center">
          {emailResponsable ? (
            <Button
              href={
                "mailto:" +
                emailResponsable +
                "?Subject=Demande de réservation de la salle : " +
                nomSalle
              }
              rel="noreferrer"
            >
              {t("public.boutons.je_commande")}
            </Button>
          ) : (
            <Button href={ReduxInstance.urlReservationSalle} target="_blank" rel="noreferrer">
              {t("public.boutons.je_reserve")}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ComponentCalendrier;
